var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 10,
    height: 10,
    transform: "translate(1205 205)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_27",
    "data-name": "Mask Group 27",
    transform: "translate(-1205 -205)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1204 204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1,6A5.079,5.079,0,0,1,6,2a5.079,5.079,0,0,1,5,4,5.079,5.079,0,0,1-5,4A5.079,5.079,0,0,1,1,6ZM6,8.5A2.5,2.5,0,1,0,3.5,6,2.5,2.5,0,0,0,6,8.5Zm0-1A1.5,1.5,0,1,0,4.5,6,1.5,1.5,0,0,0,6,7.5Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEye);
export default __webpack_public_path__ + "static/media/white-eye.17685433bad5203157623f443c9f9b8b.svg";
export { ForwardRef as ReactComponent };